var _excluded = ["table", "keyColumn", "labelColumn", "iconColumn", "settings"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import { LIST_VIEW_ROW_HEIGHTS, ListViewNormalized, useSpectrumThemeProvider } from '@deephaven/components';
import useFormatter from "../useFormatter.js";
import useViewportData from "../useViewportData.js";
import { useItemRowDeserializer } from "./utils/index.js";
import { jsx as _jsx } from "react/jsx-runtime";
export function ListView(_ref) {
  var _props$density;
  var table = _ref.table,
    keyColumnName = _ref.keyColumn,
    labelColumnName = _ref.labelColumn,
    iconColumnName = _ref.iconColumn,
    settings = _ref.settings,
    props = _objectWithoutProperties(_ref, _excluded);
  var _useSpectrumThemeProv = useSpectrumThemeProvider(),
    scale = _useSpectrumThemeProv.scale;
  var itemHeight = LIST_VIEW_ROW_HEIGHTS[(_props$density = props.density) !== null && _props$density !== void 0 ? _props$density : 'regular'][scale];
  var _useFormatter = useFormatter(settings),
    formatValue = _useFormatter.getFormattedString;
  var deserializeRow = useItemRowDeserializer({
    table,
    iconColumnName,
    keyColumnName,
    labelColumnName,
    formatValue
  });
  var _useViewportData = useViewportData({
      reuseItemsOnTableResize: true,
      table,
      itemHeight,
      deserializeRow
    }),
    viewportData = _useViewportData.viewportData,
    onScroll = _useViewportData.onScroll;
  return /*#__PURE__*/_jsx(ListViewNormalized
  // eslint-disable-next-line react/jsx-props-no-spreading
  , _objectSpread(_objectSpread({}, props), {}, {
    normalizedItems: viewportData.items,
    showItemIcons: iconColumnName != null,
    onScroll: onScroll
  }));
}
export default ListView;
//# sourceMappingURL=ListView.js.map